(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["whatsapp-order-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
  var btn = e.target.closest('.whatsapp-order-btn');
  if (!btn) return;

  var phoneNumber = (btn.getAttribute('data-phone') || '').replace(/[^0-9]/g, '');
  var productTitle = btn.getAttribute('data-title') || '';
  var messageTemplate = btn.getAttribute('data-message') || 'Hi, I want to place the order for {product}';
  var message = messageTemplate.replace('{product}', productTitle);

  var url = 'https://wa.me/' + phoneNumber + '?text=' + encodeURIComponent(message);
  window.open(url, '_blank');
});
  } catch(e) { console.error(e); }
})();

})();
